
<div class="site-panel w-100">
    <v-form ref="form">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab" >
                <f-title class="mt-0" :title="$t('unit.escalator.general')" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <!-- usually corrected by the app (HCIT-912); the office resolves type conflicts here (HCIT-943),
                             always through the type endpoint -->
                        <f-enum-select
                            v-model       = "type"
                            :label        = "$t('unit.escalator.siteType')"
                            module        = "msd"
                            type          = "siteType"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                            @input        = "onTypeChanged"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model       = "spec.escalatorKind"
                            :label        = "$t('unit.escalator.kind')"
                            module        = "msd"
                            type          = "siteEscalatorKind"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-autocomplete
                            v-model       = "spec.manufacturer"
                            :label        = "$t('unit.escalator.manufacturer')"
                            module        = "msd"
                            type          = "manufacturer"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-year-select
                            v-model       = "spec.yearOfConstruction"
                            :label        = "$t('unit.escalator.yearOfConstruction')"
                            :from         = "1900"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-autocomplete
                            v-model       = "spec.rebuilder"
                            :label        = "$t('unit.escalator.rebuilder')"
                            module        = "msd"
                            type          = "manufacturer"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-year-select
                            v-model       = "spec.yearOfRebuild"
                            :label        = "$t('unit.escalator.yearOfRebuild')"
                            :from         = "1900"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.model"
                            :label         = "$t('unit.escalator.model')"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            class          = "mb-2"
                            autocomplete   = "off"
                            spellcheck     = "false"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.escalatorType"
                            :label         = "$t('unit.escalator.type')"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            class          = "mb-2"
                            autocomplete   = "off"
                            spellcheck     = "false"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model       = "spec.escalatorAuditBook"
                            :label        = "$t('unit.escalator.auditBook')"
                            module        = "msd"
                            type          = "siteEscalatorAuditBook"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" :title="$t('unit.escalator.mounting')" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-combobox
                            v-model       = "spec.floorRange"
                            :items        = "names('siteEscalatorFloorRange')"
                            :label        = "$t('unit.escalator.floorRange')"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-combobox
                            v-model       = "spec.drivingDirection"
                            :items        = "directions"
                            :label        = "$t('unit.escalator.drivingDirection')"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model       = "spec.escalatorMountingPosition"
                            :label        = "$t('unit.escalator.mountingPosition')"
                            module        = "msd"
                            type          = "siteEscalatorMountingPosition"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>

            <v-col class="main-middlle-col modal-tab">
                <f-title class="mt-0" :title="$t('unit.escalator.technical')" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.liftingheight"
                            :label         = "$t('unit.escalator.liftingHeight')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            autocomplete   = "off"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-combobox
                            v-model       = "spec.gradient"
                            :items        = "names('siteEscalatorGradient')"
                            :label        = "$t('unit.escalator.gradient')"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-combobox
                            v-model       = "spec.stepWidthMm"
                            :items        = "names('siteEscalatorStepWidth')"
                            :label        = "$t('unit.escalator.stepWidthMm')"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.speed"
                            :label         = "$t('unit.escalator.speed')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            autocomplete   = "off"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.horizontalStepsTop"
                            :label         = "$t('unit.escalator.horizontalStepsTop')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            autocomplete   = "off"
                            @keypress      = "checkInteger"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.horizontalStepsBottom"
                            :label         = "$t('unit.escalator.horizontalStepsBottom')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            autocomplete   = "off"
                            @keypress      = "checkInteger"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" :title="$t('unit.escalator.features')" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-3">
                        <v-checkbox
                            v-for         = "item in lighting"
                            :key          = "item.property"
                            v-model       = "spec[item.property]"
                            :label        = "$t('unit.escalator.lighting.' + item.key)"
                            :ripple       = "false"
                            class         = "mt-0"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            dense
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-checkbox
                            v-model       = "spec.sprinkler"
                            :label        = "$t('unit.escalator.sprinkler')"
                            :ripple       = "false"
                            class         = "mt-0"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            dense
                        />
                        <v-text-field
                            v-if           = "spec.lightingOther"
                            v-model        = "spec.lightingOtherText"
                            :label         = "$t('unit.escalator.lighting.otherText')"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                            maxlength      = "255"
                            class          = "mt-2"
                            autocomplete   = "off"
                        />
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>

            <v-col class="main-middlle-col modal-tab">
                <f-title class="mt-0" :title="$t('unit.escalator.otherFeatures')" />
                <v-row class="no-frame">
                    <v-textarea
                        v-model        = "spec.features"
                        class          = "pt-0"
                        :readonly      = "readonly"
                        rows           = "6"
                        no-resize
                        autocomplete   = "off"
                        spellcheck     = "false"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>

            <v-col class="main-last-col modal-tab">
                <!-- LM4-only data of older escalators, kept so nothing gets lost (HCIT-937) -->
                <f-title class="mt-0" :title="$t('unit.escalator.additional')" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model       = "spec.stepType"
                            :label        = "$t('unit.escalator.legacy.stepType')"
                            module        = "msd"
                            type          = "siteEscalatorStepType"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model       = "spec.balustradeType"
                            :label        = "$t('unit.escalator.legacy.balustradeType')"
                            module        = "msd"
                            type          = "siteEscalatorBalustradeType"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model       = "spec.locationDrive"
                            :label        = "$t('unit.escalator.legacy.locationDrive')"
                            module        = "msd"
                            type          = "siteEscalatorLocationDrive"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model       = "spec.lighting"
                            :label        = "$t('unit.escalator.legacy.lighting')"
                            module        = "msd"
                            type          = "siteEscalatorLighting"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model       = "spec.socleSurface"
                            :label        = "$t('unit.escalator.legacy.socleSurface')"
                            module        = "msd"
                            type          = "siteEscalatorSocleSurface"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            class         = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-checkbox
                            v-model       = "spec.socleBrush"
                            :label        = "$t('unit.escalator.legacy.socleBrush')"
                            :ripple       = "false"
                            class         = "mt-4"
                            :hide-details = "true"
                            :readonly     = "readonly"
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.stepWidth"
                            :label         = "$t('unit.escalator.legacy.stepWidth')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.stepsRunout"
                            :label         = "$t('unit.escalator.legacy.stepsRunout')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.stepsAccessible"
                            :label         = "$t('unit.escalator.legacy.stepsAccessible')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.layerDistance"
                            :label         = "$t('unit.escalator.legacy.layerDistance')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            v-model        = "spec.switchPeriod"
                            :label         = "$t('unit.escalator.legacy.switchPeriod')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            v-model        = "spec.switchCosts"
                            :label         = "$t('unit.escalator.legacy.switchCosts')"
                            type           = "number"
                            class          = "inputNumber mb-2"
                            :hide-details  = "true"
                            :readonly      = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-read-only-field
                            :value = "spec.mountingPosition || '---'"
                            :label = "$t('unit.escalator.legacy.mountingPosition')"
                            class  = "w-100"
                            :line  = "false"
                            dense
                        />
                        <f-read-only-field
                            :value = "spec.storageAuditBook || '---'"
                            :label = "$t('unit.escalator.legacy.auditBook')"
                            class  = "w-100 mt-2"
                            :line  = "false"
                            dense
                        />
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>
        </v-row>
    </v-form>
</div>
